import { imageUrl } from '@helpers/image';
import CtaLink from '@stories/Components/CtaLink/CtaLink';
import * as React from 'react';
import S from './FeaturedLinkCard.styles';
const FeaturedLinkCard = (props) => {
    return (React.createElement(S.Container, { href: props.url, target: props.target },
        React.createElement(S.ImageWrapper, null,
            React.createElement(S.Image, { src: imageUrl(props.image, { width: 365, height: 250 }), alt: props.image.altText, role: !props.image.altText ? 'presentation' : undefined, loading: "lazy" })),
        React.createElement(CtaLink, { as: "span" }, props.text)));
};
export default FeaturedLinkCard;
